module.exports = __webpack_public_path__ + "img/Inna-logo-small.f973a930.svg";